export const CLOSE_DIGITALSIGNATURE = 'DS.CLOSE_DIGITALSIGNATURE';
